<template>
  <div>
    <div class="text-brand-5 text-weight-bold">
      {{ props.labelSuperior }}
      <span class="text-negative" v-if="props.required">*</span>
    </div>
    <q-select
      v-model="fornecedor"
      :options="listaFornecedores"
      @filter="filterFn"
      @input-value="setModel"
      use-input
      dense
      map-options
      outlined
      option-label="fantasyName"
      option-value="cnpj"
      :display-value="
        fornecedor?.fantasyName?.length > 20 && props.hidenLabel
          ? `${fornecedor?.fantasyName.substring(0, 20)}..`
          : fornecedor?.fantasyName
      "
      clearable
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-italic text-grey">
            Nenhum fornecedor encontrado
          </q-item-section>
        </q-item>
      </template>

      <template v-slot:option="scope">
        <q-item v-bind="scope.itemProps">
          <q-item-section>
            <q-item-label>{{ scope.opt.fantasyName }}</q-item-label>
            <q-item-label caption>
              {{ scope.opt.businessName }} - {{ scope.opt.cnpj }}
            </q-item-label>
          </q-item-section>
        </q-item>
      </template>
      <q-tooltip v-if="fornecedor?.fantasyName">
        {{ fornecedor?.fantasyName }}
      </q-tooltip>
    </q-select>
  </div>
</template>

<script setup>
import { ref, defineEmits, watch, defineProps } from "vue";
import { useStore } from "vuex";

const emit = defineEmits(["enviarFornecedor"]);
const props = defineProps([
  "model",
  "reset",
  "labelSuperior",
  "hidenLabel",
  "required",
]);
const time = ref();
const store = useStore();

const fornecedor = ref(props.model);
const listaFornecedores = ref([]);

const listarFornecedores = async (val) => {
  try {
    const response = await store.dispatch("gdcStore/getFornecedor", {
      per_page: 10,
      page: 1,
      search: val,
    });

    listaFornecedores.value = response.data.results.data.map((fornecedor) => ({
      id: fornecedor.id,
      businessName: fornecedor.business_name,
      fantasyName: fornecedor.fantasy_name,
      cnpj: fornecedor.cnpj,
    }));
  } catch (error) {
    console.error("Erro ao listar fornecedores:", error);
    listaFornecedores.value = [];
  }
};

const filterFn = (val, update) => {
  clearTimeout(time.value);
  time.value = setTimeout(() => {
    update(async () => {
      await listarFornecedores(val);
    });
  }, 300);
};

const setModel = (val) => {
  if (val === "") {
    fornecedor.value = null;
  }
};

watch(
  () => fornecedor.value,
  (newVal) => {
    emit("enviarFornecedor", newVal);
  }
);

watch(
  () => props.reset,
  () => {
    if (props.reset) {
      fornecedor.value = null;
      listaFornecedores.value = [];
    }
  }
);

watch(
  () => props.model,
  (newVal) => {
    fornecedor.value = newVal;
  }
);
</script>

<style scoped>
/* Adicione estilos personalizados se necessário */
</style>
